import getFeaturedPublishers from './getFeaturedPublishers';
import getWhatshotPublishers from './getWhatshotPublishers';
import getPopularNowPublishers from './getPopularNowPublishers';
import getNearMePublishers from './getNearMePublishers';
import getDirectoryPublishers from './getDirectoryPublishers';
import getRecommendedPublishers from './getRecommendedPublishers';
import setSearchText from './search/setSearchText';
import setWhatshotEnabled from './search/setWhatshotEnabled';
import toggleIndustryFilter from './search/toggleIndustryFilter';
import clearIndustryFilters from './search/clearIndustryFilters';

const actions = {
    getFeaturedPublishers,
    getWhatshotPublishers,
    getPopularNowPublishers,
    getNearMePublishers,
    getDirectoryPublishers,
    getRecommendedPublishers,
    setSearchText,
    setWhatshotEnabled,
    toggleIndustryFilter,
    clearIndustryFilters,
};

export default actions;
